import { render } from "./EmergeMessage.vue?vue&type=template&id=9883ece2&lang=true"
import script from "./EmergeMessage.vue?vue&type=script&lang=js"
export * from "./EmergeMessage.vue?vue&type=script&lang=js"

import exportComponent from "/home/lino-guzman/code/descargas/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__